import React from 'react';
import { getIconLabelAndComponent } from './getIconLabelAndComponent';

/**
 * Enum delle Icone disponibili
 * Quando si aggiunge un'icona è necessario aggiornare la funzione getIconLabelAndComponent()
 */
export enum IconType {
  Nessuna = 'Nessuna',
  ArrowRightOutlined = 'ArrowRightOutlined',
  ArrowLeftOutlined = 'ArrowLeftOutlined',
  PlusOutlined = 'PlusOutlined',
  MinusOutlined = 'MinusOutlined',
  CheckOutlined = 'CheckOutlined',
  FilePdfOutlined = 'FilePdfOutlined',
  FileZipOutlined = 'FileZipOutlined',
  DownloadOutlined = 'DownloadOutlined',
  FileOutlined = 'FileOutlined',
}

export interface IIconType {
  icon: React.ReactNode | undefined;
  type: IconType;
  label: string;
}
/**
 * Elenco delle Icone disponibili
 * con label e componente
 */
export const IconTypeList: IIconType[] = Object.entries(IconType).map(
  ([key, value]) => getIconLabelAndComponent(value),
);

export function getIconFromType(type?: IconType | null) {
  if (!type) return undefined;
  const icon = IconTypeList.find(i => i.type === type);
  if (!icon) {
    throw new Error(`Icona non trovata per il tipo ${type}`);
  }
  return icon.icon;
}
